// Kept in its own module because jsdom does not allow `window.location.assign` to be spied on.
export const assignLocation = (url: string): void => {
  window.location.assign(url);
};
